import React, { useState } from "react"
import Modal, { Action } from "@kit/design/modal"
import Icon from "@kit/design/icon"
import escapeHTML from "../../utils/escape-html"
import SlateNode from "../slate-node"

export function Code({ attributes, data, children, node }) {
  const { language, text } = data
  const className = ["code", language && `language-${language}`]
    .filter(Boolean)
    .join(" ")

  return (
    <SlateNode
      node={node}
      className={className}
      style={{
        padding: "8px",
        border: "1px solid rgba(229,231,235, 1)",
        borderRadius: 4,
        fontSize: "14px",
        position: "relative"
      }}
      {...attributes}
    >
      <pre>
        <code
          dangerouslySetInnerHTML={{
            __html: escapeHTML(text)
          }}
        />
      </pre>
      {children}
    </SlateNode>
  )
}

function CodeEmail({ attributes, data }) {
  return <Code attributes={attributes} data={data} />
}

function CodeNode({ data, editor, node, attributes, editing }) {
  const [code, setCode] = useState(data.text)
  const [active, setActive] = useState(false)

  const handleCancel = () => {
    setActive(false)
  }

  const handleSave = () => {
    editor.setNodeByKey(node.key, { data: { text: code } })
    setActive(false)
  }

  const handleChange = event => {
    setCode(event.target.value)
  }

  return (
    <Code attributes={attributes} data={data}>
      {editing && (
        <>
          <button
            contentEditable={false}
            className="absolute top-0 right-0 p-2 text-sm text-gray-600"
            onClick={() => setActive(true)}
            type="button"
          >
            <Icon name="edit" />
          </button>
          {active && (
            <Modal label="Edit Code" onClose={handleCancel}>
              <textarea
                className="font-mono border border-gray-300 rounded-sm p-2 w-full"
                onKeyDown
                onChange={handleChange}
                value={code}
              />
              <Action is="secondary" onClick={handleCancel}>
                Cancel
              </Action>
              <Action is="primary" onClick={handleSave}>
                Save
              </Action>
            </Modal>
          )}
        </>
      )}
    </Code>
  )
}

export default {
  component: CodeNode,
  email: CodeEmail,
  schema: {
    isVoid: true
  }
}
